import {DOCUMENT,isPlatformBrowser} from '@angular/common';
import {InjectionToken,LOCALE_ID,PLATFORM_ID,inject} from '@angular/core';
import {environment} from '../../../environments/environment';
import {loadScript} from '../load-script';
import {ConsentService} from '../consent/consent.service';

export interface FacebookSdk{XFBML:{parse:(element?:Element)=>void}}

export const FACEBOOK_SDK=new InjectionToken<()=>Promise<FacebookSdk|null>>('facebook.sdk',{
	providedIn:'root',
	factory:()=>{
		const isBrowser=isPlatformBrowser(inject(PLATFORM_ID));
		const document=inject(DOCUMENT);
		const consent=inject(ConsentService);
		const locale=inject(LOCALE_ID)==='es' ? 'es_LA' : 'en_US';
		const src=`https://connect.facebook.net/${locale}/sdk.js#xfbml=1&version=v22.0&appId=${environment.facebook.appId}`;
		let pending:Promise<FacebookSdk|null>|null=null;
		return ():Promise<FacebookSdk|null>=>{
			if(!isBrowser||!consent.marketing()){
				return Promise.resolve(null);
			}
			pending??=loadScript(document,src).then(()=>document.defaultView?.FB ?? null);
			return pending;
		};
	}
});
